var React = require('react');

function Union (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.292893 1.70711C-0.097631 1.31658 -0.097631 0.683418 0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6.02326 4.60904L10.3394 0.292893C10.7299 -0.0976311 11.3631 -0.0976311 11.7536 0.292893C12.1441 0.683418 12.1441 1.31658 11.7536 1.70711L7.43747 6.02326L11.7536 10.3394C12.1441 10.7299 12.1441 11.3631 11.7536 11.7536C11.3631 12.1441 10.7299 12.1441 10.3394 11.7536L6.02326 7.43747L1.70711 11.7536C1.31659 12.1441 0.68342 12.1441 0.292896 11.7536C-0.0976282 11.3631 -0.0976282 10.7299 0.292896 10.3394L4.60904 6.02326L0.292893 1.70711Z","fill":"#222224"}));
}

Union.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = Union;

Union.default = Union;
